export const ROUTE_SIGNUP = { key: 'sign-up', path: '/sign-up', noAuth: true }
export const ROUTE_VERIFY = {
  key: 'verification',
  path: '/verification',
  noAuth: true,
}
export const ROUTE_SIGNIN = { key: 'sign-in', path: '/sign-in', noAuth: true }
export const ROUTE_CHANGEPASSWORD = {
  key: 'change-password',
  path: '/change-password',
  noAuth: true,
}
export const ROUTE_EXPIRATION = {
  key: 'expiration',
  path: '/expiration',
  noAuth: true,
}
export const ROUTE_PASSWORD_SUCCESS = {
  key: 'password-success',
  path: '/password-changed',
  noAuth: true,
}

export const ROUTE_PROFILE = { key: 'profile', path: '/profile' }
export const ROUTE_SETUP_MFA = { key: 'setup-mfa', path: '/setup-mfa' }
export const ROUTE_ORG_SETTINGS = { key: 'org-settings', path: '/org-settings' }
export const ROUTE_MIGRATION = { key: 'migration', path: '/extra-info' }
export const ROUTE_BILLING = { key: 'billing', path: '/billing' }

const ROUTES_ADMIN = [
  {
    key: 'dashboard',
    path: '/dashboard',
    component: 'Dashboard',
    showMenu: true,
    roles: ['admin'],
    sections: [
      'organization-metrics',
      'recently-registered-clients',
      'account-breakdown',
      'clients-location',
    ],
  },
  {
    key: 'organization',
    path: '/organizations',
    component: 'Clients',
    showMenu: true,
    icon: 'IconBusiness',
    roles: ['admin', 'manager', 'consulting'],
    sections: [
      'organizations-table',
      'usfcr-staff',
      'organization-members',
      'files',
      'assigned-forms',
      'adjusment-forms',
      'manage-features',
      'billing-settings',
      'claimed-vendor',
      'activity-history',
    ],
  },
  {
    key: 'registered-users',
    path: '/users',
    component: 'Users',
    showMenu: true,
    icon: 'IconUser',
    roles: ['admin', 'manager', 'consulting'],
    sections: ['registered-users-table', 'registered-users-new'],
  },
  {
    key: 'usfcr-staff',
    path: '/usfcr-staff',
    component: 'UsfcrStaff',
    showMenu: true,
    icon: 'IconUSFCRStaff',
    roles: ['admin', 'manager', 'consulting'],
    sections: ['usfcr-staff-table'],
  },
  {
    key: 'admin-actions',
    path: '/admin-actions',
    component: 'AdmninActions',
    showMenu: true,
    icon: 'IconHistory',
    roles: ['admin'],
    sections: ['usfcr-staff-table'],
  },
  {
    key: 'tooltips-management',
    path: '/tooltips-management',
    component: 'TooltipsManagement',
    showMenu: true,
    icon: 'IconUser',
    roles: ['admin'],
    sections: ['tooltips-added'],
  },
  {
    key: 'releases',
    path: '/releases',
    component: 'Releases',
    showMenu: true,
    icon: 'IconReleases',
    roles: ['admin'],
    sections: ['releases-table', 'create-release'],
  },
  {
    key: 'teaming-opportunities',
    path: '/teaming-opportunities',
    component: 'TeamingOpportunities',
    showMenu: true,
    icon: 'IconTeamingOpportunities',
    roles: ['admin'],
    sections: ['teaming-opportunities-table'],
  },
  {
    key: 'org-logo-review',
    path: '/org-logo-review',
    component: 'OrgLogoReview',
    showMenu: true,
    icon: 'IconOrgLogoReview',
    roles: ['admin'],
    sections: ['request-templates-table'],
  },
  {
    key: 'admin-portal-roles',
    path: '/admin-portal-roles',
    component: 'AdminPortalRoles',
    showMenu: true,
    icon: 'IconAdminRoles',
    roles: ['admin'],
    sections: ['admin-portal-roles-table', 'create-admin-portal-roles'],
  },
  {
    key: 'role-editor',
    // Display-only sidebar label; the route key/path stay frozen. The page
    // header keeps using trans('role-editor').
    menuLabel: 'organization-permissions',
    path: '/role-editor',
    component: 'OrganizationRoleEditor',
    showMenu: true,
    icon: 'IconAdminRoles',
    roles: ['admin'],
    sections: ['role-editor-table'],
  },

  {
    key: 'global-settings',
    path: '/global-settings',
    component: 'GlobalSettings',
    showMenu: true,
    icon: 'IconSettings',
    roles: ['admin'],
    sections: [
      'formstack-management',
      'api-key-configuration',
      'default-free-account-features',
      'default-premium-account-features',
      'default-SAP-requests',
      'default-SAM-requests',
    ],
  },
  {
    key: 'event-management',
    path: '/event-management',
    component: 'EventManagement',
    showMenu: true,
    icon: 'IconEventManagement',
    roles: ['admin'],
    sections: ['manage-events'],
  },
  {
    key: 'resource-links',
    path: '/resource-links',
    component: 'ResourceLinks',
    showMenu: true,
    icon: 'IconBusinessCenter',
    roles: ['admin'],
    sections: [
      'formstack-management',
      'api-key-configuration',
      'default-free-account-features',
      'default-premium-account-features',
      'default-SAP-requests',
      'default-SAM-requests',
    ],
  },
  {
    key: 'subscription-settings',
    path: '/subscription-settings',
    component: 'SubscriptionSettings',
    showMenu: true,
    icon: 'IconVerify',
    roles: ['admin'],
    sections: ['subscription-settings-table'],
  },
  {
    key: 'course-levels',
    path: '/course-levels',
    component: 'CourseLevels',
    showMenu: true,
    icon: 'IconCourses',
    roles: ['admin'],
    sections: ['course-levels-table'],
  },
  {
    key: 'requested-quotes',
    path: '/requested-quotes',
    component: 'RequestedQuotes',
    showMenu: true,
    icon: 'IconSettings',
    roles: ['admin', 'consulting'],
    sections: ['requested-quotes-table'],
  },
  {
    key: 'submitted-forms',
    // Display-only menu label; the route key and path stay frozen.
    menuLabel: 'submitted-worksheets',
    path: '/submitted-forms',
    component: 'SubmittedForms',
    showMenu: true,
    icon: 'IconForms',
    roles: ['admin'],
    sections: ['submitted-forms-table'],
  },
  {
    key: 'request-templates',
    path: '/request-templates',
    component: 'RequestTemplates',
    showMenu: true,
    icon: 'IconSettings',
    roles: ['admin'],
    sections: ['request-templates-table'],
  },
  {
    key: 'email-templates',
    path: '/email-templates',
    component: 'EmailTemplates',
    showMenu: true,
    icon: 'IconEmail',
    roles: ['admin'],
    sections: ['request-templates-table'], // TODO: change to email-templates-table
  },
]

// Flat lookup of every admin route, keyed by route key. Used to compose the
// grouped APP_MENU below without duplicating route definitions. Keeping this
// map means the grouped menu references the exact same route objects (same
// keys/paths/components) — the reorganization is presentation-only.
const ROUTE_BY_KEY = ROUTES_ADMIN.reduce((acc, route) => {
  acc[route.key] = route
  return acc
}, {})

const groupItems = keys => keys.map(key => ROUTE_BY_KEY[key]).filter(Boolean)

// Standalone Dashboard link, rendered above the accordion groups.
const DASHBOARD_GROUP = {
  key: 'dashboard',
  standalone: true,
  items: groupItems(['dashboard']),
}

// Five collapsible accordion groups. Group `key`s resolve to i18n labels
// (en.json / ru.json). The visible label for some children differs from the
// route key (e.g. `role-editor` -> "Organization Permissions",
// `submitted-forms` -> "Submitted Worksheets"); those labels are set in i18n
// while the route keys/paths remain frozen.
const USERS_ORGANIZATIONS_GROUP = {
  key: 'users-organizations',
  icon: 'IconBusiness',
  items: groupItems(['organization', 'registered-users', 'usfcr-staff']),
}

const ACCESS_SECURITY_GROUP = {
  key: 'access-security',
  icon: 'IconAdminRoles',
  items: groupItems(['role-editor', 'admin-portal-roles', 'admin-actions']),
}

const CONTENT_COMMUNICATIONS_GROUP = {
  key: 'content-communications',
  icon: 'IconEmail',
  items: groupItems([
    'tooltips-management',
    'releases',
    'email-templates',
    'request-templates',
    'resource-links',
    'event-management',
  ]),
}

const REQUESTS_WORKSHEETS_GROUP = {
  key: 'requests-worksheets',
  icon: 'IconForms',
  items: groupItems([
    'requested-quotes',
    'submitted-forms',
    'teaming-opportunities',
    'org-logo-review',
  ]),
}

const SYSTEM_CONFIGURATION_GROUP = {
  key: 'system-configuration',
  icon: 'IconSettings',
  items: groupItems([
    'global-settings',
    'subscription-settings',
    'course-levels',
  ]),
}

// Flat list of all admin menu items, preserved for consumers that need the
// ungrouped set (e.g. the Tooltips Management "select where" picker).
export const ADMIN_MENU_ITEMS = ROUTES_ADMIN

export const adminMenuLabelKey = routeKey =>
  ADMIN_MENU_ITEMS.find(route => route.key === routeKey)?.menuLabel || routeKey

export const APP_MENU = [
  DASHBOARD_GROUP,
  USERS_ORGANIZATIONS_GROUP,
  ACCESS_SECURITY_GROUP,
  CONTENT_COMMUNICATIONS_GROUP,
  REQUESTS_WORKSHEETS_GROUP,
  SYSTEM_CONFIGURATION_GROUP,
]
